var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lunbo"},[_c('img',{staticStyle:{"width":"400px","height":"300px"},attrs:{"src":_vm.ImgSrc}}),_c('p',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }